const UPDATES = [
  {
    date: '2024.07.31',
    title: '白云视频暑期片单重磅上线',
    desc: '暑期档热门电影、电视剧集中上线，国产大片与海外巨制同步更新，陪你度过清凉一夏。新增大片专区，一键直达暑期最强片单。',
    tag: '平台公告',
  },
  {
    date: '2024.07.28',
    title: '播放器全面升级，4K画质上线',
    desc: '全新播放引擎上线，支持4K超高清画质播放，智能带宽自适应确保流畅不卡顿。同时优化了移动端播放体验，功耗更低更省电。',
    tag: '功能更新',
  },
  {
    date: '2024.07.25',
    title: '海外影视专区正式开放',
    desc: '韩剧、美剧、日剧专区独立上线，新增分类筛选和字幕切换功能。热门海外剧集与播出地同步更新，追剧不再有时差。',
    tag: '内容更新',
  },
  {
    date: '2024.07.20',
    title: '投屏功能全新改版',
    desc: '支持DLNA和AirPlay双协议投屏，一键将手机上的白云视频内容投射到电视大屏。家庭观影体验全面升级，与家人共享高清影视。',
    tag: '功能更新',
  },
  {
    date: '2024.07.15',
    title: '动漫频道内容扩容2000+',
    desc: '新增国漫、日漫热门番剧2000余部，覆盖经典老番与当季新番。动漫专区独立呈现，追番体验更加专注便捷。',
    tag: '内容更新',
  },
  {
    date: '2024.07.10',
    title: '用户反馈通道正式上线',
    desc: '新增内容反馈与建议提交入口，用户可对片源质量、播放体验提出意见。我们珍视每一条反馈，持续优化白云视频的服务品质。',
    tag: '平台公告',
  },
  {
    date: '2024.07.05',
    title: '纪录片频道全新策划上线',
    desc: '精选BBC、NHK、CCTV等顶级制作机构的优质纪录片，覆盖自然、历史、科技、人文四大主题，为您打开认知世界的新窗口。',
    tag: '内容更新',
  },
  {
    date: '2024.07.01',
    title: '白云视频新版首页改版完成',
    desc: '全新首页界面设计，优化内容分类与推荐算法。热门内容一目了然，个性化推荐更懂您的观影口味。新用户引导流程也更清晰友好。',
    tag: '平台公告',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          白云视频平台更新与内容动态，持续为您带来更好的观影体验
        </p>
        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="flex flex-col gap-6">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative pl-10 md:pl-14">
                <div className={`absolute left-2.5 md:left-4.5 top-1 w-3 h-3 rounded-full border-2 ${
                  i === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-50 border-background-300'
                }`}></div>
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                    item.tag === '平台公告'
                      ? 'bg-primary-100 text-primary-700'
                      : item.tag === '功能更新'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}